var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-lg-12\">\n<div kendo-tabstrip=\"moduloCtrl.tabLivello\" k-options=\"moduloCtrl.tabOpts\">\n<ul>\n<li class=\"k-state-active\">Gruppi</li>\n<li>Utenti</li>\n</ul>\n<div>\n<div ng-include=\"'tabgruppi.html'\"></div>\n</div>\n<div>\n<div ng-include=\"'tabutenti.html'\"></div>\n</div>\n</div>\n</div>\n";
var id1="maintpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;